import React from 'react'

// Delete confirmation modal (design spec §3): dark backdrop, 380px dialog,
// CANCEL (grey) + DELETE (red #a33).
const DeleteConfirm = ({ name, onCancel, onConfirm }) => (
  <div className="td-modal-overlay">
    <div className="td-modal">
      <div className="td-modal-title">Delete this track?</div>
      <div className="td-modal-body">
        &ldquo;{name}&rdquo; and its recorded data will be permanently removed. This can&rsquo;t be undone.
      </div>
      <div className="td-modal-buttons">
        <button className="td-btn td-modal-cancel" onClick={onCancel}>CANCEL</button>
        <button className="td-btn td-modal-delete" onClick={onConfirm}>DELETE</button>
      </div>
    </div>
  </div>
)

export default DeleteConfirm
